/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2BoardsClipboardIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2BoardsClipboardIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2BoardsClipboardIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "currentColor"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2BoardsClipboardIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 24"
 style={{'--as-1-ZVSNQc': alignSelf,'--mt-2-ZVSNQc': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZVSNQc': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZVSNQc': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZVSNQc': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZVSNQc': opacity,'--w-10-ZVSNQc': typeof width === 'number' ? `${width}px` : width,'--h-11-ZVSNQc': typeof height === 'number' ? `${height}px` : height,'--f-12-ZVSNQc': fill,'--a-7-ZVSNQc': isAnimated ? animation : "none",'--sd-8-ZVSNQc': isAnimated ? strokeDashoffset : 0,'--sd-9-ZVSNQc': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2BoardsClipboardIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M7.658.333c-.909 0-1.645.737-1.645 1.645v.823c0 .908.736 1.645 1.645 1.645h4.934c.909 0 1.645-.737 1.645-1.645v-.823c0-.908-.736-1.645-1.645-1.645H7.658zM3.956 1.978h-.822A2.467 2.467 0 00.667 4.446v16.449a2.467 2.467 0 002.467 2.467h13.982a2.467 2.467 0 002.467-2.467V4.445a2.467 2.467 0 00-2.467-2.467h-.823v.823a3.701 3.701 0 01-3.7 3.7H7.657a3.701 3.701 0 01-3.702-3.7v-.823zm11.021 8.06c.546.41.656 1.182.247 1.728l-4.934 6.58a1.234 1.234 0 01-1.672.285l-2.467-1.644a1.234 1.234 0 011.368-2.053l1.497.997 4.234-5.646a1.234 1.234 0 011.727-.247z"
 style={{'--f-12-ZVSNQc': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}